import React from 'react';
import { QuoteIcon } from 'lucide-react';
const statSlots = [0, 1, 2, 3];
const testimonialSlots = [0, 1, 2];
export function CrmProof() {
  return <section className="bg-white px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-48" data-mp="1536iw10e0f0l">
      <div className="mx-auto max-w-7xl" data-id="element-49" data-mp="r3ezfkr3q6f7">
        <h2 className="text-3xl font-extrabold tracking-tight text-brand-black sm:text-4xl" data-id="element-50" data-mp="r6j9uzv5tyeb">Results from local businesses</h2>

        <dl className="mt-12 grid grid-cols-2 divide-brand-light border-y border-brand-light lg:grid-cols-4 lg:divide-x" data-id="element-51" data-mp="hdvf0anqq4i8">
          {statSlots.map(i => <div key={i} className="flex flex-col-reverse px-4 py-8 text-center" data-id="element-52" data-mp="m76s2tj5bhil">
              <dt className="mt-2 text-sm text-brand-gray" data-id="element-53" data-mp="7hscv4sw25va">[STAT LABEL — TBD]</dt>
              <dd className="text-3xl font-extrabold text-brand-red sm:text-4xl" data-id="element-54" data-mp="cg2cbrlnbsmp">[STAT — TBD]</dd>
            </div>)}
        </dl>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-55" data-mp="3un9n9zt2ndq1">
          {testimonialSlots.map(i => <figure key={i} className="flex flex-col rounded-2xl border-2 border-dashed border-gray-300 bg-gray-50 p-8" data-id="element-56" data-mp="3gf7swxme6pf">
              <QuoteIcon className="h-6 w-6 text-brand-red" aria-hidden="true" data-id="element-57" data-mp="1hmtdpb9kb1v9" />
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-brand-gray" data-id="element-58" data-mp="1vmay7eftrsyt">[TESTIMONIAL — TBD]</blockquote>
              <figcaption className="mt-6 border-t border-gray-200 pt-4" data-id="element-59" data-mp="1qmq0t8gazso7">
                <span className="block text-sm font-bold text-brand-black" data-id="element-60" data-mp="12xn7328ea9dc">[NAME — TBD]</span>
                <span className="block text-sm text-brand-gray" data-id="element-61" data-mp="12vapwrago31c">[BUSINESS — TBD]</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}